export default {
  getMovilView(state) {
    return state.mobileView
  },
  getUltrawidelView(state) {
    return state.ultrawideView
  },
  getMovilLandcape(state) {
    return state.mobileLandscape
  },
  getVisibilityMenu(state) {
    return state.menuVisibility
  },
  getdominio(state) {
    //FIXME para subir al servidor
      return ("/"+ state.subcarpeta)
      
    //Local
      // return ("abriendo-el-juego/"+ state.subcarpeta)
     
    // return state.url
  },
  getImageURL(state) {
    return (state.imageUrl)
  },
  getUploadsURL(state) {
    return (state.uploadsUrl)
  },
  getScrollD(state) {
    return state.scrollD
  },
  getRootURL(state) {    
    // if (process.env.NODE_ENV === 'production') {
    //   console.log('production')
    //   return (state.rooturl+state.subcarpeta + "/")
    // } else {
    //   console.log('development')
    //   return ("/abriendo-el-juego/"+state.subcarpeta + "/")
    // }
    //console.log(state.rooturl+state.subcarpeta )
    return state.rooturl+state.subcarpeta 
  },
  getLinks: (state) => (path) => {
    if (path == "home") {
      //console.log(state.menulinks)
      return state.menulinks
    } else if (path == "proyecto") {
      //console.log(state.proyectoslinks)
      return state.proyectoslinks
    } else if (path == "novedades") {
      //console.log(state.novedadeslinks)
      return state.novedadeslinks
    } else if (path == "encuentro2022") {
      return state.encuentrolinks2022
    } else if (path == "encuentro2024") {
      return state.encuentrolinks2024
    } else if (path == "encuentro2026") {
      // console.log("encuentrolinks2026")
      return state.encuentrolinks2026
    }
  },
  getStyleObject: (state) => (path) => {
    let fontColor,
      headerFontColor,
      fontHoberColor,
      borderColor,
      backgroundColor
    if (path == "home") {
      //console.log("get ligth style")
      fontColor=  state.mode.ligth.color;
      headerFontColor=  state.mode.ligth.headerColor;
      fontHoberColor=  state.mode.ligth.colorhober;
      backgroundColor= state.mode.ligth.background;
      borderColor= state.mode.ligth.border;
    } else if (path == "experiencias") {
      fontColor=  state.mode.experiencias.color;
      headerFontColor=  state.mode.experiencias.headerColor;
      fontHoberColor=  state.mode.experiencias.colorhober;
      backgroundColor= state.mode.experiencias.background;
      borderColor= state.mode.experiencias.border;
    } else if (path == "juegos") {
      fontColor=  state.mode.juegos.color;
      headerFontColor=  state.mode.juegos.headerColor;
      fontHoberColor=  state.mode.juegos.colorhober;
      backgroundColor= state.mode.juegos.background;
      borderColor= state.mode.juegos.border;
    } else if (path == "dispositivos") {
      fontColor=  state.mode.dispositivos.color;
      headerFontColor=  state.mode.dispositivos.headerColor;
      fontHoberColor=  state.mode.dispositivos.colorhober;
      backgroundColor= state.mode.dispositivos.background;
      borderColor= state.mode.dispositivos.border;
    } 
    else {
      //console.log('no es nada')
      //console.log("get dark style")
      fontColor=  state.mode.dark.color;
      headerFontColor=  state.mode.dark.headerColor;
      fontHoberColor=  state.mode.dark.colorhober;
      backgroundColor= state.mode.dark.background;
      borderColor= state.mode.dark.border;
    }
    return {
      "--fontColor": fontColor,
      "--headerFontColor": headerFontColor,
      "--fontHoberColor": fontHoberColor,
      "--backgroundColor": backgroundColor,
      "--fontBorderColor": borderColor
    }
  },
}